"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FixedDef = exports.InputDef = void 0;
class InputDef {
    constructor(value) {
        this.value = value;
        this.value = value;
    }
    get masked() {
        return this.value;
    }
    get unmasked() {
        return this.value;
    }
}
exports.InputDef = InputDef;
class FixedDef {
    constructor(value) {
        this.value = value;
        this.value = value;
    }
    get masked() {
        return this.value;
    }
    get unmasked() {
        return '';
    }
}
exports.FixedDef = FixedDef;
//# sourceMappingURL=charDefs.js.map